import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import { DESIGN_TOKENS } from '@/lib/design/theme';
import { ActivityIndicator, View } from 'react-native';

export function LoadingState({ label = 'Loading...' }: { label?: string }) {
  return (
    <View className="items-center px-5 py-20">
      <ActivityIndicator color={DESIGN_TOKENS.colors.accent} />
      <Text variant="small" className="mt-4 text-muted-foreground">
        {label}
      </Text>
    </View>
  );
}

export function ErrorState({
  title = 'Something went wrong.',
  body,
  actionLabel = 'Try again',
  onAction,
}: {
  title?: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <Card className="mx-5 mt-6 gap-0 py-0">
      <CardHeader className="px-5 pt-5">
        <CardTitle className="text-xl font-semibold">{title}</CardTitle>
      </CardHeader>
      <CardContent className="px-5 pb-5 pt-3">
        <Text variant="muted" className="leading-6">
          {body}
        </Text>
      </CardContent>
      {onAction ? (
        <Button onPress={onAction} className="mx-5 mb-5 items-center justify-center">
          <Text className="font-semibold">{actionLabel}</Text>
        </Button>
      ) : null}
    </Card>
  );
}

export function EmptyState({
  title,
  body,
  actionLabel,
  onAction,
}: {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <Card className="mx-5 gap-0 py-0">
      <CardHeader className="px-5 pt-5">
        <CardTitle className="text-xl font-semibold">{title}</CardTitle>
      </CardHeader>
      <CardContent className="px-5 pb-5 pt-3">
        <Text variant="muted" className="leading-6">
          {body}
        </Text>
      </CardContent>
      {actionLabel && onAction ? (
        <Button onPress={onAction} className="mx-5 mb-5 items-center justify-center">
          <Text className="font-semibold">{actionLabel}</Text>
        </Button>
      ) : null}
    </Card>
  );
}
